module.exports = __webpack_public_path__ + "static/media/simon160px.b5b113f9.jpg";